import { ChangeEvent, useEffect, useState } from "react"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { AlertType, Cidade, Estado, RetAPI, TPessoa } from "../../Utils/Types"
import logo from '../../assets/imagens/logo.png'
import { IoMail } from "react-icons/io5"
import { DataSearch, SearchBox } from "../../Components/SearchBox/SearchBox"
import { AttributesProps, GetUFList } from "../Login/LoginService"

import { CadastroEmpresaService, Empresa } from "./cadastro-empresa-service"
import { FaHome } from "react-icons/fa"

export const CadastroEmpresaCliente = () => {

    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    const [razaoSocial, setRazaoSocial] = useState("")
    const [nomeFantasia, setNomeFantasia] = useState("")
    const [loading, setLoading] = useState(false)
    const [tipoPessoa, setTipoPessoa] = useState<TPessoa>("JURIDICA")
    const [placHolderDoc, setPlacHolderDoc] = useState("CNPJ")
    const [documentoUsuario, setDocumentoUsuario] = useState("")
    const [logradouroUsuario, setLogradouroUsuario] = useState("")
    const [bairroUsuario, setBairroUsuario] = useState("")
    const [cepUsuario, setCepUsuario] = useState("")
    const [numeroUsuario, setNumeroUsuario] = useState("")
    const [nomeUsuario, setNomeUsuario] = useState("")
    const [idUfUsuario, setIdUfUsuario] = useState("")
    const [emailUsuario, setEmailUsuario] = useState("")
    const [cadastroUsuario, setCadastroUsuario] = useState(false)

    // --------- SEARCHBOX ------------------------------------------------------------
    const [visibleSearchBoxUF, setVisibleSearchBoxUF] = useState<boolean>(false)
    const [visibleSearchBoxCity, setVisibleSearchBoxCity] = useState<boolean>(false)

    const [attributesCitys, setAttributesCitys] = useState<AttributesProps>({ ufList: [], cidadesList: [] })

    /*
    const [ufList, setUFList] = useState<DataSearch[]>([])
    const [uf, setUF] = useState()
    const [idUF, setIdUF] = useState(0)
   
    const [cityList, setCityList] = useState<DataSearch[]>([])
    const [idCity, setIdCity] = useState(0)
    */

    const [idUf, setIdUf] = useState(0)
    const [uf, setUf] = useState<Estado[]>([])
    const [siglaUf, setSiglaUf] = useState("")

    const [idCity, setIdCity] = useState(0)
    const [cidade, setCidade] = useState<Cidade[]>([])


    useEffect(() => {
        getUFAttributesList()
    }, [])

    /*
    useEffect(() => {

        if (parseInt(idUfUsuario) > 0) {
            let newUFList = [...attributesCitys.ufList]

            newUFList = newUFList.filter(item => item.id === parseInt(idUfUsuario))

            if (newUFList.length > 0) {
                const sigla = newUFList[0].sigla
                let newCityList = [...attributesCitys.cidadesList]
                newCityList = newCityList.filter(item => item.uf === sigla)
                setIdCity(0)
                setCidade(newCityList)
            }
        }

    }, [idUfUsuario])
    */

    const changeCepUsuario = (e: ChangeEvent<HTMLInputElement>) => {
        setCepUsuario(e.target.value);
    }

    const changeEmailUsuario = (e: ChangeEvent<HTMLInputElement>) => {
        setEmailUsuario(e.target.value);
    }

    const changeNumeroUsuario = (e: ChangeEvent<HTMLInputElement>) => {
        setNumeroUsuario(e.target.value);
    }

    const changeNomeUsuario = (e: ChangeEvent<HTMLInputElement>) => {
        setNomeUsuario(e.target.value);
    }

    const changeLogradouroUsuario = (e: ChangeEvent<HTMLInputElement>) => {
        setLogradouroUsuario(e.target.value);
    }

    const changeBairroUsuario = (e: ChangeEvent<HTMLInputElement>) => {
        setBairroUsuario(e.target.value);
    }

    const changeDocumentoUsuario = (e: ChangeEvent<HTMLInputElement>) => {
        setDocumentoUsuario(e.target.value);
    }

    const changeTipoPessoa = (e: ChangeEvent<HTMLSelectElement>) => {
        if (e.target.value == "FISICA") {
            setTipoPessoa("FISICA")
            setPlacHolderDoc("CPF")
        } else {
            setTipoPessoa("JURIDICA")
            setPlacHolderDoc("CNPJ")
        }
    }

    const changeRazaoSocial = (e: ChangeEvent<HTMLInputElement>) => {
        setRazaoSocial(e.target.value)
    }

    const changeNomeFantasia = (e: ChangeEvent<HTMLInputElement>) => {
        setNomeFantasia(e.target.value);
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ESTADO --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearUfSelecionada = () => {

        setSiglaUf("")
        setIdUf(0)

        updateUfList()

        setCidade([])
        setIdCity(0)

        setVisibleSearchBoxUF(false)
        //boxFocusUF()
    }

    const handleFilterUfClick = (description: string) => {

        if (description === "") {

            updateUfList()

        } else {

            const newUfList = [...attributesCitys?.ufList || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setUf(newUfList || [])
        }

    }

    const handleUfSelectClick = (data: any) => {

        if (data.id > 0) {

            setIdUf(data.id)
            setSiglaUf(data.sigla)
            setarCidades(data.sigla)

        } else {
            setIdUf(0)
            setSiglaUf('')
            setarCidades('')
        }

        updateUfList()
        setIdCity(0)

        setVisibleSearchBoxUF(false)
        //boxFocusUF()

        //setIdUfUsuario(data.id)
    }

    const updateUfList = () => {
        const newUfList = [...attributesCitys?.ufList || []]
        setUf(newUfList)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CIDADE --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearCidadeSelecionada = () => {
        setIdCity(0)
        setarCidades(siglaUf)

        setVisibleSearchBoxCity(false)
        //boxFocusCidade()

        //const newCityList: DataSearch[] = []
        //setCidade(newCityList)
    }

    const handleFilterCidadeClick = (description: string) => {

        if (description.trim() === "") {

            setarCidades(siglaUf)

        } else {

            let newCidadeList = []

            newCidadeList = [...attributesCitys?.cidadesList || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase()) &&
                    item.uf === siglaUf
            })

            setCidade(newCidadeList)
        }
    }

    const handleCidadeSelectClick = (data: any) => {
        if (data) {
            setIdCity(data.id)
            setarCidades(siglaUf)
        }

        setVisibleSearchBoxCity(false)
        //boxFocusCidade()

    }

    const setarCidades = async (uf: string) => {
        const citys = await attributesCitys?.cidadesList.filter(item => item.uf === uf)
        setCidade(citys || [])
    }

    const fecharCadastroUsuario = () => {
        setCadastroUsuario(false)
        setVisible(false)
    }

    const CadastroClick = async () => {
        const empresa: Empresa = {
            razao: razaoSocial,
            fantasia: nomeFantasia,
            tipoPessoa: tipoPessoa,
            documento: documentoUsuario,
            nome: nomeUsuario,
            logradouro: logradouroUsuario,
            bairro: bairroUsuario,
            cep: cepUsuario,
            numero: numeroUsuario,
            uf: siglaUf || '',
            cidade: idCity.toString(),
            email: emailUsuario,
        }
        setLoading(true)
        const retorno: RetAPI = await CadastroEmpresaService.save(empresa)
        setLoading(false)

        if (retorno.error === false) {
            setMessageType('DANGER')
            setMessage(retorno.msg || '')
            setVisible(true)
        } else {
            setMessageType('SUCCESS')
            setMessage('Empresa cadastrada com sucesso')
            setVisible(true)
        }
    }

    const getUFAttributesList = async () => {
        const attributes = await GetUFList()
        setAttributesCitys(attributes)
        setUf(attributes.ufList)
        setCidade(attributes.cidadesList)
        //setUFList(attributes.ufList)
        //setCityList(attributes.cidadesList)
    }

    return (

        <div className="h-[1500px] md:h-[1300px] lg:h-[1000px] w-full py-5">

            <div className={`flex flex-col justify-center w-[90%] md:w-3/4 h-auto rounded-lg mx-auto shadow-lg shadow-indigo-200 transition-all duration-300 bg-white border border-indigo-200`}>

                <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`flex items-center w-full h-[120px] border-b border-indigo-200`}>
                    <FaHome className={`text-cyan-700 w-10 h-10 mx-2`} />
                    <span className={`font-serif text-3xl text-cyan-700 font-bold`}>Cadastro de empresa</span>
                </div>

                <div className={`grid grid-cols-12 gap-4 w-full px-5 py-2`}>

                    <div className={`relative col-span-12 lg:col-span-6`}>

                        <span className={`text-slate-400 font-mono`}>Razão Social</span>
                        <div className={`flex justify-end items-center w-full h-auto relative`}>
                            <input id="razaoSocial" className={`w-full h-[50px] border border-slate-300 rounded-md pl-4 outline-none focus:border-indigo-500 mt-2 text-indigo-600 text-base transition-all duration-300 font-mono pr-[60px] ${loading ? 'opacity-40 bg-slate-200' : ''}`} type="text" placeholder="Empresa teste Ltda." autoComplete="off" value={razaoSocial} disabled={loading} onChange={changeRazaoSocial} />
                        </div>

                    </div>

                    <div className={`relative col-span-12 lg:col-span-6`}>

                        <span className={`text-slate-400 font-mono`}>Nome fantasia</span>
                        <div className={`flex justify-end items-center w-full h-auto relative`}>
                            <input id="nomeFantasia" className={`w-full h-[50px] border border-slate-300 rounded-md pl-4 outline-none focus:border-indigo-500 mt-2 text-indigo-600 text-base transition-all duration-300 font-mono pr-[60px] ${loading ? 'opacity-40 bg-slate-200' : ''}`} type="text" placeholder="Empresa teste" autoComplete="off" value={nomeFantasia} disabled={loading} onChange={changeNomeFantasia} />
                        </div>

                    </div>

                    <div className={`relative col-span-12 md:col-span-4 lg:col-span-6`}>

                        <span className={`text-slate-400 font-mono`}>Tipo pessoa</span>
                        <select className={`w-full h-[50px] border border-slate-300 rounded-md outline-none px-4 focus:border-indigo-500 mt-2 text-indigo-600 text-base transition-all duration-300 font-mono ${loading ? 'opacity-40 bg-slate-200' : ''}`} value={tipoPessoa} onChange={changeTipoPessoa}>
                            <option value="JURIDICA">Jurídica</option>
                            <option value="FISICA">Física</option>
                        </select>

                    </div>

                    <div className={`relative col-span-12 md:col-span-8 lg:col-span-6`}>

                        <span className={`text-slate-400 font-mono`}>Documento</span>
                        <div className={`flex justify-end items-center w-full h-auto relative`}>
                            <input id="documentoUsuario" className={`w-full h-[50px] border border-slate-300 rounded-md pl-4 outline-none focus:border-indigo-500 mt-2 text-indigo-600 text-base transition-all duration-300 font-mono pr-[60px] ${loading ? 'opacity-40 bg-slate-200' : ''}`} type="text" placeholder={placHolderDoc} autoComplete="off" value={documentoUsuario} disabled={loading} onChange={changeDocumentoUsuario} />
                        </div>

                    </div>

                    <div className={`relative col-span-12`}>

                        <span className={`text-slate-400 font-mono`}>Nome</span>
                        <div className={`flex justify-end items-center w-full h-auto relative`}>
                            <input id="nomeUsuario" className={`w-full h-[50px] border border-slate-300 rounded-md pl-4 outline-none focus:border-indigo-500 mt-2 text-indigo-600 text-base transition-all duration-300 font-mono pr-[60px] ${loading ? 'opacity-40 bg-slate-200' : ''}`} type="text" placeholder="Digite seu nome" autoComplete="off" value={nomeUsuario} disabled={loading} onChange={changeNomeUsuario} />
                        </div>

                    </div>

                    <div className={`relative col-span-12`}>
                        <span className={`text-slate-400 font-mono`}>Logradouro</span>
                        <div className={`flex justify-end items-center w-full h-auto relative`}>
                            <input id="logradouro" className={`w-full h-[50px] border border-slate-300 rounded-md pl-4 outline-none focus:border-indigo-500 mt-2 text-indigo-600 text-base transition-all duration-300 font-mono pr-[60px] ${loading ? 'opacity-40 bg-slate-200' : ''}`} type="text" placeholder="Rua João da Silva" autoComplete="off" value={logradouroUsuario} disabled={loading} onChange={changeLogradouroUsuario} />
                        </div>
                    </div>

                    <div className={`relative col-span-12 lg:col-span-6`}>

                        <span className={`text-slate-400 font-mono`}>Bairro</span>
                        <div className={`flex justify-end items-center w-full h-auto relative`}>
                            <input id="bairroUsuario" className={`w-full h-[50px] border border-slate-300 rounded-md pl-4 outline-none focus:border-indigo-500 mt-2 text-indigo-600 text-base transition-all duration-300 font-mono pr-[60px] ${loading ? 'opacity-40 bg-slate-200' : ''}`} type="text"
                                placeholder="Centro" autoComplete="off" value={bairroUsuario}
                                disabled={loading} onChange={changeBairroUsuario} />
                        </div>

                    </div>

                    <div className={`relative col-span-12 md:col-span-6 lg:col-span-3`}>

                        <span className={`text-slate-400 font-mono`}>CEP</span>
                        <div className={`flex justify-end items-center w-full h-auto relative`}>
                            <input id="cepUsuario" className={`w-full h-[50px] border border-slate-300 rounded-md pl-4 outline-none focus:border-indigo-500 mt-2 text-indigo-600 text-base transition-all duration-300 font-mono pr-[60px] ${loading ? 'opacity-40 bg-slate-200' : ''}`} type="text"
                                placeholder="00.000-000" autoComplete="off" value={cepUsuario}
                                disabled={loading} onChange={changeCepUsuario} />
                        </div>

                    </div>

                    <div className={`relative col-span-12 md:col-span-6 lg:col-span-3`}>

                        <span className={`text-slate-400 font-mono`}>Número</span>
                        <div className={`flex justify-end items-center w-full h-auto relative`}>
                            <input id="numeroUsuario" className={`w-full h-[50px] border border-slate-300 rounded-md pl-4 outline-none focus:border-indigo-500 mt-2 text-indigo-600 text-base transition-all duration-300 font-mono pr-[60px] ${loading ? 'opacity-40 bg-slate-200' : ''}`} type="text" placeholder="S/N" autoComplete="off" value={numeroUsuario} disabled={loading} onChange={changeNumeroUsuario} />
                        </div>

                    </div>

                    <div className={`relative col-span-12 lg:col-span-6`}>

                        <span className={`text-slate-400 font-mono`}>Estado</span>
                        <div className="mt-2 relative">
                            <SearchBox
                                dataList={uf}
                                idRegistro={idUf || undefined}
                                componentId='uf'
                                borda={true}
                                visibleTAB={visibleSearchBoxUF}
                                disabled={loading}
                                clearDataClick={handleClearUfSelecionada}
                                setDataClick={handleUfSelectClick}
                                filterDataClick={handleFilterUfClick}
                            />
                        </div>


                    </div>

                    <div className={`relative col-span-12 lg:col-span-6`}>

                        <span className={`text-slate-400 font-mono `}>Cidade</span>
                        <div className="mt-2 relative">
                            <SearchBox
                                dataList={cidade}
                                idRegistro={idCity || undefined}
                                componentId='cidade'
                                borda={true}
                                visibleTAB={visibleSearchBoxCity}
                                disabled={loading}
                                clearDataClick={handleClearCidadeSelecionada}
                                setDataClick={handleCidadeSelectClick}
                                filterDataClick={handleFilterCidadeClick}
                            />
                        </div>

                    </div>

                    <div className={`relative col-span-12`}>

                        <span className={`text-slate-400 font-mono`}>E-mail</span>
                        <div className={`flex justify-end items-center w-full h-auto relative`}>
                            <input id="e-mailUsuario" className={`w-full h-[50px] border border-slate-300 rounded-md pl-4 outline-none focus:border-indigo-500 mt-2 text-indigo-600 text-base transition-all duration-300 font-mono pr-[60px] ${loading ? 'opacity-40 bg-slate-200' : ''}`} type="email" placeholder="Digite seu e-mail" autoComplete="off" value={emailUsuario} disabled={loading} onChange={changeEmailUsuario} />
                            <span className={`absolute mr-[20px] mt-2 h-full flex items-center text-slate-400 outline-none`}>
                                <IoMail size="30px" />
                            </span>
                        </div>

                    </div>

                    <div className={`relative col-span-12 flex justify-center mt-2`}>

                        <button disabled={loading} onClick={CadastroClick} className={`w-1/2 h-[50px] bg-green-600 text-white hover:bg-green-700 rounded-xl transition-all duration-300 font-mono ${loading ? 'opacity-40' : ''}`}>
                            {loading ? 'Aguarde...' : 'Cadastrar'}
                        </button>

                    </div>

                    <div className={`relative col-span-12 flex justify-center`}>

                        <a href="/login" className={'text-sm text-blue-600 my-2 duration-150 hover:text-blue-800 hover:font-bold'}>
                            Já tenho conta
                        </a>

                    </div>

                </div>

            </div>

        </div>

    )

}